export default __webpack_public_path__ + "static/media/news_show_1.2da03fe4.png";